import axios from '@/axiosInterceptor';

const state = () => ({
  recentReports: [],
  myReports: [],
  pagination: {
    recentReports: {
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
    },
    myReports: {
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
    },
  },
});

// getters
const getters = {};

// actions
const actions = {
  async getRecentReports({ commit }, { page, perPage }) {
    const params = {
      page,
      'q[site_eq]': 'tiawatchdog.com',
      'q[created_at_gteq]': `${calculateSevenDaysAgoTimestamp()}`,
      'q[s]': 'created_at desc',
      per_page: perPage,
    };
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/identity_alerts',
        { params }
      );
      commit('setRecentReports', res.data);
      commit('setPaginationRecentReports', res.headers);
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getMyReports({ commit }, { companyId, page, userId }) {
    const params = {
      page,
      'q[site_eq]': 'tiawatchdog.com',
      per_page: 50,
      'q[s]': 'created_at desc',
    };
    if (companyId) {
      params['q[company_id_eq]'] = companyId;
    }

    if (userId) {
      params['q[user_id_eq]'] = userId;
    }

    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/identity_alerts',
        { params }
      );
      commit('setMyReports', res.data);
      commit('setPaginationMyReports', res.headers);
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setRecentReports(state, data) {
    state.recentReports = data;
  },
  setMyReports(state, data) {
    state.myReports = data;
  },
  setPaginationRecentReports(state, headers) {
    if (headers) {
      state.pagination.recentReports = {
        currentPage: parseInt(headers.currentpage),
        totalPages: parseInt(headers.totalpages),
        totalRecords: parseInt(headers.totalitems),
      };
    }
  },
  setPaginationMyReports(state, headers) {
    if (headers) {
      state.pagination.myReports = {
        currentPage: parseInt(headers.currentpage),
        totalPages: parseInt(headers.totalpages),
        totalRecords: parseInt(headers.totalitems),
      };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

function calculateSevenDaysAgoTimestamp() {
  const millisecondsInADay = 1000 * 60 * 60 * 24; // 1 day in milliseconds
  const currentTime = new Date();
  const sevenDaysAgo = new Date(currentTime.getTime() - 7 * millisecondsInADay);

  return sevenDaysAgo.getTime();
}
